


















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

enum signType {
  signIn = 1,
  signOut,
  signOutOffline,
  signOutFail
}

interface days {
  day: number,
  type: signType
}

interface signData {
  type: signType,
  do_time: number,
  days: days[],
  count_time: number,
  count_day: number
}

@Component
export default class signIn extends Vue {
  @Prop() private value: boolean;
  @Prop() signData: signData;

  bgSingIn = require('../assets/imgs/bg-sign-in.png');
  bgSingOut = require('../assets/imgs/bg-sign-out.png');
  bgSingOutFail = require('../assets/imgs/bg-sign-out-fail.png');
  bgSingOffline = require('../assets/imgs/bg-sign-out-offline.png');
  signSuccess = require('../assets/imgs/sign-success.png');
  now: string = '';
  themeColor: string = process.env.VUE_APP_THEME_COLOR;
  
  get calendarAttrs() {
    const res = [
      {
        key: 'today',
        highlight: {
          class: 'today',
          contentClass: 'today-content'
        },
        dates: new Date(),
      },
      { // 正常
        dot: {
          style: {
            backgroundColor: '#04D601',
          }
        },
        dates: [],
      },
      {// 异常
        dot: {
          style: {
            backgroundColor: '#FEA43B',
          }
        },
        dates: [],
      },
      { // 线下
        dot: {
          style: {
            backgroundColor: '#ccc',
          }
        },
        dates: [],
      }
    ];

    const today:number = Number((this as any).$moment().format('YYYYMMDD'));
    
    for (const item of this.signData.days) {
      if(today === item.day) {
        item.type = this.signData.type
      }
      const date = new Date(
        Number(String(item.day).slice(0, 4)),
        Number(String(item.day).slice(4, 6)) - 1,
        Number(String(item.day).slice(6, 8))
      )

      if(item.type === 2) {
        (res[1].dates as Date[]).push(date)
      } else if(item.type === 3) {
        (res[3].dates as Date[]).push(date)
      } else if(item.type === 1 || item.type === 4) {
        (res[2].dates as Date[]).push(date)
      }
    }


    return res
  } 

  get visible() {
    return this.value
  }
  set visible(val) {
    this.$emit('input', val)
  }

  get duration() {
    return (this as any).$moment.utc(this.signData.do_time * 1000).format('HH小时mm分ss秒')
  };

  get durationTotal() {
    return (this as any).$moment.utc(this.signData.count_time * 1000).format('HH小时mm分ss秒')
  };

  @Watch('value')
  private valueChange(val) {
    const doc = document.documentElement
    if(val) {
      doc.style.overflow = 'hidden'
      const date = new Date()
      const h = date.getHours()
      const m = date.getMinutes()
      this.now = `${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}`
    } else {
      doc.style.overflow = ''
    }
  }
}
